module.exports = __webpack_public_path__ + "img/none.be6a1348.png";